import React from "react";
import { ValidatorComponent } from "react-form-validator-core";
import Multiselect from "multiselect-react-dropdown";

class MultiSelectValidator extends ValidatorComponent {
  
  // This is CRITICAL. It tells the validator to re-check 
  // whenever the parent state updates the selectedOptions prop.
  componentDidUpdate(prevProps) {
    if (this.props.selectedOptions !== prevProps.selectedOptions) {
        this.validate(this.props.selectedOptions);
    }
  }

  renderValidatorComponent() {
    const {
      allOptions,
      selectedOptions,
      onChange,
      validators,
      errorMessages,
      validatorListener,
      isRequired,
      label,
      style, 
    displayValue = "name",
    emptyRecordMsg = "No more options available",
      // name, // Remove name from rest so it doesn't double-up
      ...rest
    } = this.props;

    const { isValid } = this.state;
// Define default styles here
    const defaultStyles = {
      multiselectContainer: {
        zIndex: 1000,
        position: 'relative'
      },
      optionContainer: {
        zIndex: 1001, // Ensure the dropdown menu is above everything else
        background: '#fff'
      },
      option: {
        cursor: 'pointer' // Fixes the "selectable" issue immediately
      },
      inputField: {
        margin: '0'
      },
      ...style // Merges parent styles if you ever need to override
    };

    return (
      <div className={"form-group" + (isValid ? "" : " has-error")}>
        {label && (
          <label>
            {label} {isRequired ? <span className="text-danger">*</span> : ""}
          </label>
        )}

        <Multiselect
          options={allOptions}
          selectedValues={selectedOptions}
          onSelect={onChange}
          onRemove={onChange}
          displayValue={displayValue}
          style={defaultStyles} // Applied by default now
          emptyRecordMsg={emptyRecordMsg}
          {...rest}
        />

        {this.errorText()}
      </div>
    );
  }

  getValue() {
    // This will now be called by the form on submit
    return this.props.selectedOptions || [];
  }

  errorText() {
    const { isValid } = this.state;
    if (isValid) return null;

    return (
      <span className="help-block" style={{ color: "#a94442", display: 'block', marginTop: '5px' }}>
        {this.getErrorMessage()}
      </span>
    );
  }
}

export default MultiSelectValidator;